'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ModalDialog", "_contextual", "centered", "contextual", "use", "size", "width"];
import PropTypes from 'prop-types';
import { forwardRef, useContext } from 'react';
import { hidden } from '../utils/propTypes/decorators';
import { MODAL_USE_CLASSES } from './DialogConstants';
import AbstractModal from './internal/AbstractModal';
import ModalTransition from './internal/ModalTransition';
import UIModalDialog from './UIModalDialog';
import { createPlacementWarning, DropdownContext } from '../context/DropdownContext';
import { jsx as _jsx } from "react/jsx-runtime";
const UIModal = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      ModalDialog = UIModalDialog,
      _contextual = false,
      centered = false,
      contextual = false,
      use = 'default',
      size = 'auto',
      width = 450
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    shouldLogModalWarning
  } = useContext(DropdownContext);
  const _createPlacementWarning = createPlacementWarning(UIModal.displayName);
  if (shouldLogModalWarning) {
    _createPlacementWarning();
  }
  return /*#__PURE__*/_jsx(AbstractModal, Object.assign({}, rest, {
    centered: centered,
    contextual: contextual,
    use: use,
    size: size,
    width: width,
    ModalDialog: ModalDialog,
    _contextual: _contextual,
    componentName: "UIModal",
    Transition: ModalTransition,
    ref: ref
  }));
});
UIModal.propTypes = Object.assign({}, UIModalDialog.propTypes, {
  centered: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Identifies what component is rendered within `UIModal` and takes in its props. By default set to `UIModalDialog`.
   */
  ModalDialog: hidden(PropTypes.func),
  /**
   * Function that gets called when the closing animation is complete.
   */
  onCloseComplete: PropTypes.func,
  /**
   * Function that gets called when the closing animation starts
   */
  onCloseStart: PropTypes.func,
  /**
   * Function that gets called when the opening animation is complete.
   */
  onOpenComplete: PropTypes.func,
  /**
   * Function that gets called when the opening animation starts.
   */
  onOpenStart: PropTypes.func,
  /**
   * Determines how the modal is visually styled based on its use case
   */
  use: PropTypes.oneOf(Object.keys(MODAL_USE_CLASSES)),
  /**
   * Allows us to toggle between sandbox and product environment.
   */
  _contextual: PropTypes.bool,
  /**
   * The DOM node where the modal is rendered, by default set to `document.body`.
   */
  rootNode: AbstractModal.propTypes.rootNode
});
UIModal.displayName = 'UIModal';
export default UIModal;